const merge = require('lodash/merge');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');
const getWs02Token = require('@dbk-legacy/wso2token').getToken;
const getIPaddress = require('@dbk-legacy/wso2token').getIPaddress;
const base64 = require('base-64');

function apiFactory({
  baseUrl,
  requestHandler
}) {
  const headers = {
    Accept: 'application/json'
  };

  function getUrl(endpoint) {
    return `${baseUrl}${endpoint}`;
  }

  return {
    getMarqueData(channel) {
        const url = getUrl('get-adu-admin-configs');
        const reqOpts = {
          headers: merge(headers, {
            Authorization: getWs02Token(),
            'X-CLIENT-IP': getIPaddress(),
          }),
          method: 'POST'
        };
        const body = {
          channel: channel,
        };

        return requestHandler(merge(reqOpts, {
          url,
          body,
          json: true,
        }));
    },

    getAllMarqueData(channel, metaData) {
      const url = getUrl('get-all-adu-admin-configs');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST'
      };
      const body = {
        channel: channel, 
      };

      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true,
      }));
    },

    saveMarqueData(requestBody, metaData) {
      const parsedRequestBody = JSON.parse(base64.decode(requestBody));
      const url = getUrl('save-adu-admin-configs');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST'
      };
      const body = {
          configType: parsedRequestBody.configType,
          channel: parsedRequestBody.channel,
          configKeyValue: parsedRequestBody.configKeyValue,
          permanentFlag: parsedRequestBody.permanentFlag,
          validFromDt: parsedRequestBody.validFromDt,
          validToDt: parsedRequestBody.validToDt,
          flgenable: parsedRequestBody.flgenable,
          marqueId: parsedRequestBody.marqueId,
      };

      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true,
      }));
    }
  };
}

module.exports = apiFactory;